$(() => {
    $('.contBox').ready(() => {
        // スクロールでフワッと出てくる
        const fadeUpClass = 'js-fadeUp';
        const $fadeUp = $(`.${fadeUpClass}`);
        if ($fadeUp[0]) {
            $fadeUp.children().addClass(fadeUpClass);
            $fadeUp.each(function() {
                const $this = $(this);
                $this.css({
                    opacity: 0,
                    transform: 'translateY(30px) scale(.96)'
                })
                .waypoint(dir => {
                    if (dir !== 'down') return;
                    $this.css({
                        opacity: 1,
                        transform: 'translateY(0) scale(1)',
                        transition: 'all 0.8s cubic-bezier(.41, 0, .18, 1)'
                    });
                }, { offset : '110%' });
            });
        }
    });
});

